import { PieChartLegendTableRow } from './PieChartLegendTableRow';
import { useEffect, useState } from 'react';
import './PieChartLegendTable.css';
import { Box } from '@mui/material';

interface TableProps {
  species: String;
  rows: any;
}

// const tempRows = [
//   createData('#231B56', '45.1 %', 'Great black-backed gull', 1000),
//   createData('#493E8B', '31.8 %', 'Unidentified gull', 37),
//   createData('#C1B8D7', '9.4 %', 'European herring gull', 24),
//   createData('#F1B480', '4.4 %', 'Black-legged kittiwake', 67),
//   createData('#F2D5B5', '2.4 %', 'Northern gannet', 49),
//   createData('#D18543', '1.3 %', 'Lesser black-backed gull', 49),
//   createData('#7D86D9', '4.1 %', 'Other', 49),
//   createData('', '1.3 %', 'Great skua', 13),
//   createData('', '0.5 %', 'Peregrine falcon', 5),
//   createData('', '0.4 %', 'Great cormorant', 4),
//   createData('', '0.3 %', 'Greylag goose', 3),
//   createData('', '0.3 %', 'Hen harrier', 3),
//   createData('', '0.3 %', 'Unidentified duck', 3),
//   createData('', '0.3 %', 'Mew gull', 3),
//   createData('', '0.3 %', 'Unidentified loon', 3),
//   createData('', '0.2 %', 'Northern goshawk', 2),
//   createData('', '0.1 %', 'Grey heron', 1),
//   createData('', '0.1 %', 'Unidenitifed curlew', 1),
// ];

export default function PieChartLegendTable({ species, rows }: TableProps) {
  const [currentSelectedRow, setCurrentSelectedRow] =
    useState<HTMLElement | null>(null);

  useEffect(() => {
    currentSelectedRow?.classList.remove('highlight-row');
    var cols = document.getElementsByClassName(
      'legend-table-hidden-row',
    ) as HTMLCollectionOf<HTMLElement>;

    const row: HTMLElement = document.getElementById(
      species.toString(),
    ) as HTMLElement;
    const arrow: HTMLElement = document.getElementById(
      'table-arrow',
    ) as HTMLElement;
    if (species === 'Other') {
      row.style.borderBottom = '1px solid rgba(191, 185, 199, 0.4)';
      if (arrow) {
        arrow.classList.remove('down');
        arrow.classList.add('up');
      }
      for (let i = 0; i < cols.length; i++) {
        cols[i].style.display = '';
      }
    } else {
      if (currentSelectedRow) {
        currentSelectedRow.style.borderBottom = '';
      }
      if (arrow) {
        arrow.classList.remove('up');
        arrow.classList.add('down');
      }
      for (let i = 0; i < cols.length; i++) {
        cols[i].style.display = 'none';
      }
    }
    if (row) {
      setCurrentSelectedRow(row);
      row.classList.add('highlight-row');
    }
  }, [species, currentSelectedRow]);
  return (
    <table className="legend-table">
      <tbody>
        <tr>
          <th></th>
          <th>
            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
              PERCENTAGE
            </Box>
          </th>
          <th>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'left',
                paddingLeft: '38px',
              }}
            >
              SPECIES
            </Box>
          </th>
          <th>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'right',
              }}
            >
              COUNT
            </Box>
          </th>
        </tr>
        {rows.map(function (object: any, i: any) {
          return <PieChartLegendTableRow row={object} key={i} />;
        })}
      </tbody>
    </table>
  );
}
